function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import './login.scss';
import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { parseQueryParams, generateAuthLink } from 'shared/helper/link-helper';
import { Controls, validators } from 'shared/helper/form';
import featureEnabled from 'shared/helper/feature';
import { getRegisterFormFields, getChinaLocalization } from 'shared/account/reducer';
import { getLocale } from 'researcher/application/reducer';
import { CHINA_ID } from 'researcher/domain/account/country';
import { PASSWORD_MIN_LENGTH } from 'shared/helper/form/validators';
import Link from 'shared/components/Link';
import { T, useTranslate } from 'shared/helper/translate';
import { defaultValues as institutionDefaultValues } from 'shared/account/components/InstitutionForm';
import { convertFormDataToUserUpdateRequest } from 'shared/view/user-conversion-service';
import trackRubriqEvent, { initRubriqAnalytics, identifyRubriqUser, resetRubriqAnalytics } from 'rubriq/helpers/trackRubriqEvent';
import LocalizationPreferences from '../../../shared/account/components/LocalizationPreferences';
import { registerUser, verifyUser, sendPhoneOtpV2, verifyPhoneOtpV2 } from '../actions';
import { recordAgreeAndSignUp } from '../../helpers/gtm';
import OtpTimer from './OtpTimer';
import ProvidersV2 from './ProvidersV2';
var Form = Controls.Form,
  Text = Controls.Text,
  Password = Controls.Password,
  Checkbox = Controls.Checkbox;
var isEmail = validators.isEmail,
  notEmpty = validators.notEmpty,
  validPassword = validators.validPassword,
  chinesePhoneRequired = validators.chinesePhoneRequired,
  createChinesePhoneLengthValidator = validators.createChinesePhoneLengthValidator,
  createChinesePhoneNumbersOnlyValidator = validators.createChinesePhoneNumbersOnlyValidator;
var defaultValues = {
  active: true,
  addedToWatchlist: false,
  agreeToTOS: false,
  companySelection: {
    value: null
  },
  country: null,
  creditNotesLocked: false,
  currency: {
    value: null
  },
  currencySelectionDisabled: false,
  email: '',
  excludeFromDelinquentCheck: false,
  firstName: '',
  foundUs: '',
  institution: institutionDefaultValues,
  language: {
    value: null
  },
  lastName: '',
  localization: '',
  optinToMarketing: false,
  orcid: '',
  otherFoundUs: '',
  overrideDownloadAvailable: false,
  password: '',
  countryCode: {
    value: '+86',
    isoCode: 'CN'
  },
  phoneNumber: '',
  secondaryEmail: '',
  title: '',
  watchlistNotification: '',
  workplace: ''
};
function RegisterV2(_ref) {
  var _parseQueryParams$ori;
  var providers = _ref.providers,
    referringUrl = _ref.referringUrl,
    _ref$onEmailVerificat = _ref.onEmailVerificationRequired,
    onEmailVerificationRequired = _ref$onEmailVerificat === void 0 ? function () {} : _ref$onEmailVerificat,
    _ref$onSuccessfulRegi = _ref.onSuccessfulRegistration,
    onSuccessfulRegistration = _ref$onSuccessfulRegi === void 0 ? function () {} : _ref$onSuccessfulRegi,
    formData = _ref.formData;
  var dispatch = useDispatch();
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var chinaPhoneOtpEnabled = featureEnabled('rubriq_china_Phone_Otp_Enabled');
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAll = _useState2[0],
    setShowAll = _useState2[1];
  var OTP_DURATION = 60;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    otpCooldownActive = _useState4[0],
    setOtpCooldownActive = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    otpCooldownEndTime = _useState6[0],
    setOtpCooldownEndTime = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    emailVerified = _useState8[0],
    setEmailVerified = _useState8[1];
  // OTP state (China only)
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    otpSent = _useState10[0],
    setOtpSent = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    otpVerified = _useState12[0],
    setOtpVerified = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    otpVerifiedPhone = _useState14[0],
    setOtpVerifiedPhone = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    otpProcessing = _useState16[0],
    setOtpProcessing = _useState16[1];
  var OTP_LENGTH = 6;
  var otpRefs = useRef([]);
  var fields = useSelector(getRegisterFormFields);
  var processing = useSelector(function (_ref2) {
    var authentication = _ref2.authentication;
    return authentication.status.processing;
  });
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false,
    mode: 'onChange'
  });
  var errors = methods.formState.errors;
  var isPhoneValid = !!methods.watch('phoneNumber') && !errors.phoneNumber;
  var reset = methods.reset,
    watch = methods.watch,
    setValue = methods.setValue;
  var origin = (_parseQueryParams$ori = parseQueryParams(window.location.search).origin) !== null && _parseQueryParams$ori !== void 0 ? _parseQueryParams$ori : '';
  var loginLink = generateAuthLink('login', referringUrl, origin);
  var countries = useSelector(function (_ref3) {
    var account = _ref3.account;
    return account.countries;
  });
  var currencies = useSelector(function (_ref4) {
    var account = _ref4.account;
    return account.currencies;
  });
  var currentLocalization = useSelector(function (_ref5) {
    var application = _ref5.application;
    return application.currentLocalization;
  });
  var localizations = useSelector(function (_ref6) {
    var application = _ref6.application;
    return application.localizations;
  });
  var languages = useSelector(function (_ref7) {
    var account = _ref7.account;
    return account.languages;
  });
  var _useSelector = useSelector(getLocale),
    siteLanguage = _useSelector.iso639Locale;
  var password = methods.watch('password');
  var passwordTrackedRef = useRef(false);
  var signupFormViewedTracked = useRef(false);
  var _watch = watch(['currencySelectionDisabled', 'country', 'countryCode', 'phoneNumber']),
    _watch2 = _slicedToArray(_watch, 4),
    currencySelectionDisabled = _watch2[0],
    country = _watch2[1],
    countryCode = _watch2[2],
    watchedPhoneNumber = _watch2[3];
  var mixpanel = useSelector(function (_ref8) {
    var application = _ref8.application;
    return application.mixpanel.apiToken;
  });
  var isChinaUser = useSelector(getChinaLocalization);
  var isChinaSelectedInRow = !isChinaUser && (country === null || country === void 0 ? void 0 : country.value) === CHINA_ID;
  var shouldShowPhoneOtp = chinaPhoneOtpEnabled && (isChinaUser || isChinaSelectedInRow);
  useEffect(function () {
    // China deployment: Mixpanel is blocked by the Great Firewall so we skip
    // analytics initialisation entirely. Signup Completed / Signup Failed will
    // not fire for aje-china users — this is intentional. If a non-Mixpanel
    // analytics provider is ever added for China, initialise it here instead.
    if (isChinaUser) return;

    // Keep sessionStorage for same-origin SPA navigation.
    sessionStorage.setItem('rubriq_last_page', 'register');

    // Also write a short-lived cross-domain cookie so RubriqWorkspace can
    // detect a fresh registration even after a cross-origin redirect
    // (e.g. megatron domain → secure.rubriq domain).  The domain is derived
    // the same way loginUser already does for SSO cookies.
    var hostname = window.location.hostname.toLowerCase();
    var cookieDomain = '';
    if (hostname.endsWith('.sqr.io')) {
      cookieDomain = '.sqr.io';
    } else if (hostname.endsWith('.aje.com')) {
      cookieDomain = '.aje.com';
    }
    if (cookieDomain) {
      document.cookie = "rubriq_signup_pending=1; path=/; max-age=300; domain=".concat(cookieDomain, "; SameSite=None; Secure");
    }
    initRubriqAnalytics({
      mixpanelToken: mixpanel,
      rudder: {
        writeKey: '39Q5aSEScArkktyABbZD8oWdLhA',
        dataPlaneUrl: 'https://mpslimitedtyuf.dataplane.rudderstack.com'
      }
    });
  }, [isChinaUser, mixpanel, referringUrl]);
  useEffect(function () {
    if (password && !passwordTrackedRef.current) {
      passwordTrackedRef.current = true;
      trackRubriqEvent('Password Entered', {
        device: navigator.userAgent,
        landing_page: window.location.pathname,
        email: methods.getValues('email')
      });
    }
  }, [password]);
  useEffect(function () {
    if (showAll && !signupFormViewedTracked.current) {
      signupFormViewedTracked.current = true;
      trackRubriqEvent('Signup Form Viewed', {
        email: methods.getValues('email'),
        device: navigator.userAgent,
        landing_page: window.location.pathname
      });
    }
  }, [showAll]);
  useEffect(function () {
    trackRubriqEvent('Signup Page Viewed', {
      landing_page: window.location.pathname,
      device: navigator.userAgent,
      source: referringUrl || 'direct'
    });
  }, [referringUrl]);

  // phone helpers
  var phoneOptions = countries.map(function (c) {
    return {
      value: "".concat(c.isoCode, "-").concat(c.countryCode),
      label: "(".concat(c.countryCode, ") ").concat(c.name),
      isoCode: c.isoCode,
      countryCode: c.countryCode
    };
  });
  var formatOptionLabel = function formatOptionLabel(country) {
    return /*#__PURE__*/React.createElement("div", {
      className: "country-option-with-flag"
    }, /*#__PURE__*/React.createElement("img", {
      className: "country-flag",
      src: "https://flagcdn.com/w20/".concat(country.isoCode.toLowerCase(), ".png"),
      alt: "".concat(country.label, " flag")
    }), /*#__PURE__*/React.createElement("span", {
      className: "country-label"
    }, country.label));
  };
  useEffect(function () {
    setValue('phoneNumber', '');
    setValue('otp', '');
    setOtpSent(false);
    setOtpVerified(false);
    setOtpVerifiedPhone(null);
  }, [countryCode, setValue]);
  useEffect(function () {
    if (!otpVerified) return;
    if (otpVerifiedPhone !== watchedPhoneNumber) {
      setOtpSent(false);
      setOtpVerified(false);
      setValue('otp', '');
      setOtpVerifiedPhone(null);
    }
  }, [watchedPhoneNumber, otpVerified, otpVerifiedPhone, setValue]);
  useEffect(function () {
    if (!otpCooldownEndTime) {
      return undefined;
    }
    var interval = setInterval(function () {
      if (Date.now() >= otpCooldownEndTime) {
        setOtpCooldownActive(false);
        setOtpCooldownEndTime(null);
      }
    }, 500);
    return function () {
      clearInterval(interval);
    };
  }, [otpCooldownEndTime]);
  var filterOutCnyConditionally = function filterOutCnyConditionally(currencies) {
    return currencies.filter(function (currency) {
      if ((country === null || country === void 0 ? void 0 : country.value) !== CHINA_ID && !fields.admin) {
        if (currency.value !== 'CNY') {
          return true;
        }
      } else {
        return true;
      }
      return false;
    });
  };
  var handleRegisterUser = function handleRegisterUser(userUpdateRequest) {
    dispatch(registerUser(userUpdateRequest, referringUrl, origin)).then(function (result) {
      var loggedIn = result.loggedIn,
        redirectUri = result.redirectUri,
        error = result.error,
        errorType = result.errorType,
        redirected = result.redirected,
        emailVerificationRequired = result.emailVerificationRequired,
        emailVerificationPending = result.emailVerificationPending,
        email = result.email;

      // The account was created - or was already there waiting on its link
      // - and cannot be logged into until that link is followed. Signing up
      // succeeded either way, so this is not a failure to track.
      if (emailVerificationRequired) {
        recordAgreeAndSignUp({
          buttonText: t('agree-and-sign-up')
        });
        if (window.dataLayer && !emailVerificationPending) {
          window.dataLayer.push({
            event: 'signupComplete'
          });
        }
        onEmailVerificationRequired(email, emailVerificationPending);
        return;
      }

      // A China user registering on the ROW site gets redirected to the
      // China domain after a successful login — loginUser returns
      // { redirected: true } in that case. Treat it the same as loggedIn.
      if (!loggedIn && !redirected) {
        trackRubriqEvent('Signup Failed', {
          email: userUpdateRequest.userDetails.email,
          error_type: errorType || 'signup_failed',
          error_message: error || null,
          device: navigator.userAgent,
          landing_page: window.location.pathname
        });
        return;
      }
      recordAgreeAndSignUp({
        buttonText: t('agree-and-sign-up')
      });
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'signupComplete'
        });
      }
      onSuccessfulRegistration(referringUrl || redirectUri || '/');
    }).catch(function (err) {
      trackRubriqEvent('Signup Failed', {
        email: userUpdateRequest.userDetails.email,
        error_type: 'network_error',
        error_message: (err === null || err === void 0 ? void 0 : err.message) || 'unknown',
        device: navigator.userAgent,
        landing_page: window.location.pathname
      });
    });
  };
  var handlePersistData = function handlePersistData(formData) {
    // recordAgreeAndSignUp({ buttonText: t('agree-and-sign-up') });

    if (formData.email && !(formData !== null && formData !== void 0 && formData.country)) {
      trackRubriqEvent('Signup Started', {
        email: formData.email,
        device: navigator.userAgent,
        timestamp: new Date().toISOString()
      });
      dispatch(verifyUser({
        email: formData.email
      })).then(function (data) {
        // data === false means the email is already registered.
        // data === true means the email is available — show the full form.
        // Any other value (e.g. an error dispatch result) is also a failure.
        if (data !== true) {
          trackRubriqEvent('Signup Failed', {
            email: formData.email,
            error_type: 'duplicate_email',
            error_message: 'email-already-exists',
            device: navigator.userAgent,
            landing_page: window.location.pathname
          });
          return;
        }
        setShowAll(data);
        setEmailVerified(true);
      });
    } else {
      trackRubriqEvent('Signup Form Submitted', {
        email: formData.email,
        country: formData.country.label,
        marketing_opt_in: formData.optinToMarketing,
        device: navigator.userAgent
      });
      handleRegisterUser(convertFormDataToUserUpdateRequest(formData, {
        currencies: currencies,
        languages: languages
      }));
    }
  };
  var handleSendOtp = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _methods$getValues;
      var i, input, success, endTime;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!chinaPhoneOtpEnabled || otpCooldownActive)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            // Show OTP immediately
            setOtpSent(true);
            setOtpVerified(false);
            setValue('otp', '');
            setOtpVerifiedPhone(null);
            for (i = 0; i < otpRefs.current.length; i += 1) {
              input = otpRefs.current[i];
              if (input) {
                input.value = '';
              }
            }
            setOtpProcessing(true);
            _context.next = 10;
            return dispatch(sendPhoneOtpV2({
              phoneNumber: methods.getValues('phoneNumber'),
              countryCode: (_methods$getValues = methods.getValues('countryCode')) === null || _methods$getValues === void 0 ? void 0 : _methods$getValues.value,
              platform: 'rubriq',
              actionType: 'registration'
            }));
          case 10:
            success = _context.sent;
            if (success) {
              endTime = Date.now() + OTP_DURATION * 1000;
              setOtpCooldownEndTime(endTime);
              setOtpCooldownActive(true);
            }
            setOtpProcessing(false);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSendOtp() {
      return _ref9.apply(this, arguments);
    };
  }();
  var handleVerifyOtp = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var success, phoneNumber;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (chinaPhoneOtpEnabled) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            setOtpProcessing(true);
            _context2.next = 5;
            return dispatch(verifyPhoneOtpV2({
              phoneNumber: methods.getValues('phoneNumber'),
              code: methods.getValues('otp'),
              actionType: 'registration'
            }));
          case 5:
            success = _context2.sent;
            if (success) {
              phoneNumber = methods.getValues('phoneNumber');
              setOtpVerified(true);
              setOtpVerifiedPhone(phoneNumber);
            }
            setOtpProcessing(false);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleVerifyOtp() {
      return _ref10.apply(this, arguments);
    };
  }();
  var handleOtpChange = function handleOtpChange(value, index) {
    if (!/^[0-9]?$/.test(value)) return;
    var currentOtp = methods.getValues('otp') || '';
    var otpArray = currentOtp.padEnd(OTP_LENGTH, '').split('');
    otpArray[index] = value;
    methods.setValue('otp', otpArray.join(''));

    // Auto move to next box
    if (value && index < OTP_LENGTH - 1) {
      var _otpRefs$current;
      (_otpRefs$current = otpRefs.current[index + 1]) === null || _otpRefs$current === void 0 || _otpRefs$current.focus();
    }
  };
  var handleOtpKeyDown = function handleOtpKeyDown(e, index) {
    if (e.key !== 'Backspace') return;
    var currentOtp = methods.getValues('otp') || '';
    var otpArray = currentOtp.padEnd(OTP_LENGTH, '').split('');
    if (otpArray[index]) {
      // Clear current box
      otpArray[index] = '';
      methods.setValue('otp', otpArray.join(''));
    } else if (index > 0) {
      var _otpRefs$current2;
      // Move to previous box
      (_otpRefs$current2 = otpRefs.current[index - 1]) === null || _otpRefs$current2 === void 0 || _otpRefs$current2.focus();
      otpArray[index - 1] = '';
      methods.setValue('otp', otpArray.join(''));
    }
  };
  useEffect(function () {
    if (formData) {
      reset(formData);
    }
  }, [formData, reset]);
  useEffect(function () {
    if (country !== null && country !== void 0 && country.value) {
      trackRubriqEvent('Country Selected', {
        countryName: country.label,
        device: navigator.userAgent,
        landing_page: window.location.pathname,
        email: methods.getValues('email')
      });
    }
  }, [country]);
  var watchedOtp = methods.watch('otp') || '';
  return /*#__PURE__*/React.createElement("div", {
    className: "new-login mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center w-75 mx-auto"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "fw-semibold"
  }, !formData ? /*#__PURE__*/React.createElement(T, {
    source: "sign-up"
  }) : /*#__PURE__*/React.createElement(T, {
    source: "Confirm your information"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-6 have-account"
  }, /*#__PURE__*/React.createElement(Link, {
    to: loginLink
  }, /*#__PURE__*/React.createElement(T, {
    source: "I have an account"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto"
  }, formData && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(T.md, {
    source: "confirm-information-message"
  })), /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    className: "login-form clearfix",
    onSubmit: handlePersistData,
    testAttribute: "login-form"
  }, /*#__PURE__*/React.createElement(Text, {
    name: "email",
    placeholder: "work-personal-email",
    styles: {
      wrapper: 'row m-0 mb-4',
      label: 'col-4',
      controlsWrapper: 'col p-0'
    },
    messages: {
      isEmail: 'emailAddressInvalidFormat'
    },
    validators: {
      isEmail: isEmail
    },
    ariaLabel: "work-personal-email"
  }), showAll && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "password"
  }, /*#__PURE__*/React.createElement(Password, {
    placeholder: "Password",
    messages: {
      validPassword: function validPassword() {
        return /*#__PURE__*/React.createElement(T, {
          source: "password-too-short",
          params: PASSWORD_MIN_LENGTH
        });
      }
    },
    name: "password",
    validators: {
      validPassword: validPassword
    },
    styles: {
      wrapper: 'mb-0'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "row mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-50 pe-2"
  }, /*#__PURE__*/React.createElement(Text, {
    placeholder: "First name",
    styles: {
      wrapper: 'row mx-1',
      controlsWrapper: 'col p-0'
    },
    name: "firstName",
    validators: {
      notEmpty: notEmpty
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-50 ps-2"
  }, /*#__PURE__*/React.createElement(Text, {
    placeholder: "last-name",
    styles: {
      wrapper: 'row mx-1',
      controlsWrapper: 'col p-0'
    },
    name: "lastName",
    validators: {
      notEmpty: notEmpty
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(LocalizationPreferences, {
    label: "",
    allowFilterUpdates: !fields.admin,
    placeholder: "country",
    countries: countries,
    currencies: filterOutCnyConditionally(currencies),
    currencySelectionDisabled: currencySelectionDisabled,
    currentLocalization: currentLocalization,
    fields: fields.localizationPreferencesFields,
    languages: languages,
    localizations: localizations,
    methods: methods,
    siteLanguage: siteLanguage,
    styles: "border-radius"
  })), shouldShowPhoneOtp && /*#__PURE__*/React.createElement("div", {
    className: "phone-input-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "phone-input-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "country-select"
  }, /*#__PURE__*/React.createElement(Select, {
    options: phoneOptions,
    value: phoneOptions.find(function (c) {
      return c.isoCode === 'CN';
    }),
    isDisabled: true,
    isSearchable: false,
    formatOptionLabel: formatOptionLabel,
    classNamePrefix: "phone-select"
  })), /*#__PURE__*/React.createElement("div", {
    className: "phone-number-field"
  }, /*#__PURE__*/React.createElement(Text, {
    name: "phoneNumber",
    placeholder: "PHONE_NUMBER",
    maxLength: (countryCode === null || countryCode === void 0 ? void 0 : countryCode.value) === '+86' ? 11 : undefined,
    styles: {
      wrapper: 'm-0 p-0',
      label: 'd-none',
      controlsWrapper: 'm-0 p-0',
      controlClass: "phone-number-input"
    },
    disabled: otpProcessing || otpCooldownActive,
    validators: {
      chinesePhoneRequired: chinesePhoneRequired(countryCode === null || countryCode === void 0 ? void 0 : countryCode.value),
      chinesePhoneLength: createChinesePhoneLengthValidator(countryCode === null || countryCode === void 0 ? void 0 : countryCode.value),
      chinesePhoneNumbersOnly: createChinesePhoneNumbersOnlyValidator(countryCode === null || countryCode === void 0 ? void 0 : countryCode.value)
    },
    messages: {
      chinesePhoneRequired: 'contact-number-required',
      chinesePhoneLength: 'contact-number-validation',
      chinesePhoneNumbersOnly: 'contact-number-no-letters-validation'
    }
  })), isPhoneValid && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "request-otp-button",
    "aria-label": t('request otp'),
    disabled: otpProcessing || otpCooldownActive,
    onClick: handleSendOtp
  }, otpCooldownActive ? /*#__PURE__*/React.createElement(OtpTimer, {
    active: otpCooldownActive,
    seconds: otpCooldownEndTime ? Math.max(0, Math.ceil(((otpCooldownEndTime !== null && otpCooldownEndTime !== void 0 ? otpCooldownEndTime : 0) - Date.now()) / 1000)) : OTP_DURATION,
    onFinish: function onFinish() {
      setOtpCooldownActive(false);
      setOtpCooldownEndTime(null);
    }
  }) : /*#__PURE__*/React.createElement(T, {
    source: "request otp"
  }))), otpSent && /*#__PURE__*/React.createElement("div", {
    className: "otp-row"
  }, [0, 1, 2, 3, 4, 5].map(function (i) {
    return /*#__PURE__*/React.createElement("input", {
      key: i,
      type: "text",
      inputMode: "numeric",
      maxLength: 1,
      className: "otp-box",
      ref: function ref(el) {
        otpRefs.current[i] = el;
      },
      value: watchedOtp[i] || '',
      onChange: function onChange(e) {
        return handleOtpChange(e.target.value, i);
      },
      onKeyDown: function onKeyDown(e) {
        return handleOtpKeyDown(e, i);
      }
    });
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "verify-otp-button",
    "aria-label": t('verify'),
    disabled: otpProcessing || watchedOtp.length !== OTP_LENGTH,
    onClick: handleVerifyOtp
  }, /*#__PURE__*/React.createElement(T, {
    source: "verify"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "text-start mb-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "terms"
  }, /*#__PURE__*/React.createElement(T, {
    source: "terms-policy"
  }))), showAll && /*#__PURE__*/React.createElement("div", {
    className: "text-start terms mb-4"
  }, fields.marketingOptIn && /*#__PURE__*/React.createElement(Checkbox, {
    label: t('marketing-message'),
    name: "optinToMarketing"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("button", {
    id: "agree_and_signup_button",
    disabled: processing || emailVerified && shouldShowPhoneOtp && (!otpVerified || otpVerifiedPhone !== methods.getValues('phoneNumber')),
    type: "submit",
    className: "agree-button w-100",
    "aria-label": t('agree-and-sign-up')
  }, processing ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "ms-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "agree-and-sign-up"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center my-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "divider-line w-50"
  }), /*#__PURE__*/React.createElement("span", {
    className: "mx-3 split"
  }, /*#__PURE__*/React.createElement(T, {
    source: "or"
  })), /*#__PURE__*/React.createElement("div", {
    className: "divider-line w-50"
  }))), /*#__PURE__*/React.createElement(ProvidersV2, {
    providers: providers,
    referringUrl: referringUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-start"
  }, /*#__PURE__*/React.createElement("p", {
    className: "terms"
  }, /*#__PURE__*/React.createElement(T, {
    source: "privacy-policy"
  })))))));
}
export default RegisterV2;